<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import { ErrorWrapper } from '@utils/error-handler'
import { BOverlay } from 'bootstrap-vue'
import {
  authComputed,
  siteListMethod,
  userListMethod,
  departmentListMethod,
  departmentComputed,
} from '@state/helpers'

export default {
  page: {
    title: 'Add Admin',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    'b-overlay': BOverlay,
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      userRole: '',
      userError: null,
      userDataStatus: false,
      isUserError: false,
      isLoading: false,
      editorData: '',
      image: '',
      show: false,
      siteconfiglist: [],
      departmentlist: [],
      platformId: 0,
      platform: '',
      collegeId: '',
      collegeName: '',
    }
  },
  computed: {
    ...authComputed,
    ...departmentComputed,
    filteredItems() {
      return this.autocompleteItems.filter((i) => {
        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1
      })
    },
  },
  mounted() {
    this.getListOfCollege()
  },
  methods: {
    ...siteListMethod,
    ...userListMethod,
    ...departmentListMethod,
    addUserData() {
      this.isLoading = true
      this.getRole()
      const Data = {
        first_name: this.firstName,
        last_name: this.lastName,
        email: this.email,
        password: '12345678',
        phone: this.phone,
        status: 'active',
        platform_id: this.platformId,
        role: this.userRole,
        platform: this.platform,
      }
      this.addUser({ Data })
        .then((resp) => {
          this.isLoading = false
          this.$router.push({ name: 'admin.list' })
        })
        .catch((error) => {
          this.isLoading = false
          var getError = new ErrorWrapper(error)
          this.userError = getError.message
          this.isUserError = true
          window.scrollTo(0, 0)
        })
    },
    // get list of platform
    getListOfCollege() {
      this.fetchSiteList()
        .then((siteconfig) => {
          var listitems = []
          siteconfig.forEach((element) => {
            var ele = {}
            ele.text = element.site_name
            ele.value = element.platform_id
            listitems.push(ele)
          })
          this.siteconfiglist = listitems
        })
        .catch((_error) => {})
    },
    getRole() {
      if (this.platformId === 0) {
        this.userRole = 'admin'
        this.collegeId = 0
      } else {
        this.userRole = 'administrator'
        this.collegeId = this.platformId
      }
      let i = 0
      for (i = 0; i < this.siteconfiglist.length; i++) {
        if (this.platformId === this.siteconfiglist[i].value) {
          this.platform = this.siteconfiglist[i].text
          this.collegeName = this.siteconfiglist[i].text
        }
      }
    },
    restrictChars(event) {
      if (event.charCode === 32 && !this.firstName.length) {
        event.preventDefault()
      } else {
        if (
          (event.charCode >= 65 && event.charCode <= 90) ||
          (event.charCode >= 97 && event.charCode <= 122) ||
          event.charCode === 32
        ) {
          return true
        } else {
          event.preventDefault()
        }
      }
    },
    restrictChars1(event) {
      if (event.charCode === 32 && !this.lastName.length) {
        event.preventDefault()
      } else {
        if (
          (event.charCode >= 65 && event.charCode <= 90) ||
          (event.charCode >= 97 && event.charCode <= 122) ||
          event.charCode === 32
        ) {
          return true
        } else {
          event.preventDefault()
        }
      }
    },
    restrictChars2(event) {
      if (event.charCode === 32 && !this.email.length) {
        event.preventDefault()
      } else {
        if (event.charCode !== 32) {
          return true
        } else {
          event.preventDefault()
        }
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="show" :opacity="0.6" rounded="sm">
          <b-card>
            * Mandatory Fields<br /><br />
            <b-alert
              v-model="isUserError"
              variant="danger"
              v-html="userError"
            ></b-alert>
            <b-form
              data-parsley-validate
              novalidate
              @submit.prevent="addUserData"
            >
              <b-form-group label="First Name*" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="firstName"
                  type="text"
                  placeholder="Enter First Name"
                  @keypress="restrictChars($event)"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Last Name*" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="lastName"
                  type="text"
                  placeholder="Enter Last Name"
                  @keypress="restrictChars1($event)"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Email Id*" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="email"
                  type="text"
                  placeholder="Enter Email"
                  @keypress="restrictChars2($event)"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Phone Number*" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="phone"
                  type="number"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  maxlength="12"
                  placeholder="Enter Phone Number(with country code)"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                v-if="role === 'admin'"
                label="Select Platform*"
                label-for="input-1"
              >
                <b-form-select
                  v-model="platformId"
                  :options="siteconfiglist"
                  @change="getRole"
                ></b-form-select>
              </b-form-group>
              <b-form-group id="button-group" class="mt-4">
                <b-button
                  v-if="!isLoading"
                  type="submit"
                  variant="primary"
                  style="color: white"
                  >Save</b-button
                >
                <b-button
                  v-else
                  type="submit"
                  variant="primary"
                  class="btn-block"
                  disabled
                >
                  <b-spinner small></b-spinner>Loading...
                </b-button>
              </b-form-group>
              <a class="cancel-anchor" href="/user-list"
                ><b-button
                  v-if="!isLoading"
                  class="cancel"
                  type="button"
                  variant="primary"
                  >Cancel</b-button
                ></a
              >
            </b-form>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
<style>
.cancel {
  background-color: grey;
}
.cancel:hover {
  background-color: grey !important;
}
.cancel:active {
  background-color: grey !important;
}
.cancel-anchor {
  color: white !important;
}
.cancel-anchor:hover {
  color: white;
}
.vue-tags-input {
  max-width: 100% !important;
}
.ti-new-tag-input-wrapper input {
  font-family: 'Roboto', sans-serif;
  font-size: 0.9rem;
  font-weight: 400;
}
.ti-tag::before {
  display: none;
}
[class^='ti-'],
[class*=' ti-'] {
  font-size: inherit !important;
  font-weight: inherit !important;
}
</style>
